import {handleValidationChange} from '../CommonValidation';

export const validateTerminals = (data, setIsError) => {
    //Required 
    // bank_name: "",

    var isValid = true;

    if(data.name === "" || data.name === undefined) {
        handleValidationChange("name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("name", false, setIsError);
    }
    
    if(data.branch_id === "" || data.branch_id === undefined) {
        handleValidationChange("branch_id", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("branch_id", false, setIsError);
    }

    if(data.status === "" || data.status === undefined) {
        handleValidationChange("status", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("status", false, setIsError);
    }

    return isValid
  
}


export const validatePriceLevels = (data, setIsError) => {
    //Required 
    // bank_name: "",

    var isValid = true;

    if(data.name === "" || data.name === undefined) {
        handleValidationChange("name", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("name", false, setIsError);
    }

    return isValid
  
}